import { FormControlLabelProps, FormControlLabel as MuiFormControlLabel } from "@mui/material";
import { forwardRef } from "react";

type Props = FormControlLabelProps;

export const FormControlLabel = forwardRef<HTMLLabelElement, Props>((props, ref) => {
  return <MuiFormControlLabel {...props} ref={ref} />;
});
FormControlLabel.displayName = "FormControlLabel";
